<script lang="ts" setup>
import FAQItem from './FAQItem.vue';

export type QAndA = {
  q: string;
  a: string;
};

const props = defineProps<{
  faqList: QAndA[];
}>();

useJsonld(
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: props.faqList.map((qa) => ({
      '@type': 'Question',
      name: qa.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: qa.a,
      },
    })),
  },
  {
    tagPosition: 'bodyClose',
  }
);
</script>

<template>
  <div :class="$style.container">
    <p :class="[$style.container__title, $style.title]">FAQ</p>
    <p :class="[$style.container__lead, $style.lead]">
      オカネコによく寄せられる質問をまとめました
    </p>
    <ul :class="[$style.container__faqList, $style.faqList]">
      <FAQItem
        v-for="item in props.faqList"
        :key="item.q"
        :class="$style.faqList__faqItem"
      >
        <template #q>{{ item.q }}</template>
        <template #a>{{ item.a }}</template>
      </FAQItem>
    </ul>
  </div>
</template>

<style lang="scss" module>
@use '../_constants.scss' as *;

.container {
  max-width: $content-width;
  padding: 64px 16px 0 16px;

  @include mobile-only {
    padding-top: 32px;
  }
}

.title {
  font-size: 40px;
  font-weight: bold;
  line-height: 72px;
  text-align: center;

  @include mobile-only {
    font-size: 24px;
    line-height: 43.2px;
  }
}

.lead {
  font-size: 16px;
  font-weight: bold;
  line-height: 28.8px;
  text-align: center;
  color: $color-text-and-object-accent-primary;
}

.faqList {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 40px;

  @include mobile-only {
    margin-top: 32px;
  }
}
</style>
